import { render } from "./ProdutosCliente.vue?vue&type=template&id=605507bb&scoped=true"
import script from "./ProdutosCliente.vue?vue&type=script&lang=js"
export * from "./ProdutosCliente.vue?vue&type=script&lang=js"

import "./ProdutosCliente.vue?vue&type=style&index=0&id=605507bb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605507bb"]])

export default __exports__